export default "<div>deprecated public component</div>\n";